import { Grid } from "@mui/material";
import Mobile1 from "../../../../assets/socialmedia/ecommerce1-mobile.webp";
import Mobile2 from "../../../../assets/socialmedia/ecommerce2-mobile.webp";
import Web1 from "../../../../assets/socialmedia/ecommerce1-web.webp";
import Web2 from "../../../../assets/socialmedia/ecommerce2-web.webp";
import Web3 from "../../../../assets/socialmedia/ecommerce3-web.webp";
import useBreakpoints from "../../../../hooks/useBreakpoints";

export default function ECommerceContent() {
  const { isXs } = useBreakpoints();

  return (
    <Grid
      container={isXs}
      justifyContent={"center"}
      sx={{ position: "relative" }}
    >
      <img
        src={isXs ? Mobile1 : Web1}
        alt=""
        width={isXs ? "100%" : 250}
        style={{
          objectFit: "cover",
          position: isXs ? "static" : "absolute",
          left: 40,
          top: 20,
          borderRadius: isXs ? 24 : 1000,
        }}
      />
      <img
        src={isXs ? Mobile2 : Web2}
        alt=""
        width={isXs ? "100%" : 250}
        style={{
          objectFit: "cover",
          position: isXs ? "static" : "absolute",
          left: 40,
          top: 290,
          marginTop: isXs ? 15 : 0,
          borderRadius: 24,
        }}
      />
      {!isXs && (
        <img
          src={Web3}
          alt=""
          width={isXs ? "100%" : 330}
          style={{
            objectFit: "cover",
            position: isXs ? "static" : "absolute",
            left: 330,
            top: 20,
            borderRadius: 24,
          }}
        />
      )}
    </Grid>
  );
}
